import React from "react";
import ContactSection from "../components/MainSection/ContactsSection";
const Contacts = () => {
  return (
    <div>
      <ContactSection />
    </div>
  );
};

export default Contacts;
